// Add your custom JS here.
jQuery(window).scroll(function () {
  if (jQuery(this).scrollTop() > 50) {
    jQuery("header.header-site").addClass("scrolled");
  } else {
    jQuery("header.header-site").removeClass("scrolled");
  }
});

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
  $('[tabindex="0"]').keydown(function (event) {
    if (event.key === "Enter" || event.key === " ") {
      $(this).click();
    }
  });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
  const LinkGoSecondSection = document.getElementById("GoSecondSection");
  LinkGoSecondSection.addEventListener("click", function (event) {
    event.preventDefault();
    const secondSection = document.querySelector(
      ".general-section:nth-of-type(2)"
    );
    if (secondSection) {
      secondSection.scrollIntoView({ behavior: "smooth" });
    } else {
      console.error("the second section was not found.");
    }
  });
});

function autosize() {
  var el = this;
  setTimeout(function () {
    el.style.cssText = "height:auto; padding:0";
    // for box-sizing other than "content-box" use:
    // el.style.cssText = '-moz-box-sizing:content-box';
    el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
  }, 0);
}

document.fonts.ready.then(function () {
  document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
  if (typeof AOS === "undefined") return;
  jQuery(document).on("sf:ajaxfinish", function () {
    AOS.refreshHard();
  });

  var target = document.querySelector("#block-search-and-filter");
  if (target) {
    var resizeObserver = new ResizeObserver(function () {
      AOS.refreshHard();
    });
    resizeObserver.observe(target);
  }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth < 992;
  const offset = isMobile ? 180 : 230;

  function scrollToHash(hash) {
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.pageYOffset - offset,
          behavior: "smooth",
        });
      }, 50);
    }
  }

  if (window.location.hash) {
    scrollToHash(window.location.hash);
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", function (e) {
      const hash = this.getAttribute("href");
      if (hash.length > 1) {
        e.preventDefault();
        history.pushState(null, null, hash);
        scrollToHash(hash);
      }
    });
  });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
  const headerButtons = document.querySelector(".header-buttons");
  const megaMenu = document.querySelector("#mega-menu-primary");

  const liButtons = document.createElement("li");
  liButtons.className =
    "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

  let isInMegaMenu = false;

  function moveButtonsToMenu() {
    if (window.innerWidth <= 1000 && !isInMegaMenu) {
      if (headerButtons && megaMenu) {
        liButtons.appendChild(headerButtons);
        megaMenu.appendChild(liButtons);
        isInMegaMenu = true;
      }
    } else if (window.innerWidth > 1000 && isInMegaMenu) {
      const originalContainer = document.querySelector(".content-elements");
      if (originalContainer && headerButtons) {
        originalContainer.appendChild(headerButtons);
        if (liButtons.parentNode) liButtons.parentNode.removeChild(liButtons);
        isInMegaMenu = false;
      }
    }
  }

  moveButtonsToMenu();
  window.addEventListener("resize", moveButtonsToMenu);
});

(function resizeByHeading() {
  function resizeIcons() {
    const heading = document.querySelector(
      ".custom-column__content-heading .heading"
    );
    if (!heading) return;

    const height = heading.offsetHeight;
    const icons = document.querySelectorAll(
      ".custom-column__content-heading .clasp-icon img"
    );

    icons.forEach((img) => {
      img.style.height = height + "px";
      img.style.width = "auto";
    });
  }
  resizeIcons();
  window.addEventListener("resize", resizeIcons);
})();

//slider partners
document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("logo-carousel");
  if (!track) return;

  let direction     = track.dataset.direction === "right" ? "right" : "left";
  const baseSpeed   = parseFloat(track.dataset.speed || "0.6");
  const boostFactor = parseFloat(track.dataset.boost || "3");
  const gapFallback = parseFloat(track.dataset.gap || "16");

  track.style.transition = "none";
  track.style.willChange = "transform";
  track.style.backfaceVisibility = "hidden";
  track.style.transform = "translateZ(0)";

  const originals = Array.from(track.querySelectorAll(".logo-item"));
  if (!originals.length) return;

  const container = track.parentElement;

  const getFlexGap = (el) => {
    const g = parseFloat(getComputedStyle(el).columnGap);
    return Number.isFinite(g) && g > 0 ? g : 0;
  };
  const flexGap = getFlexGap(track);

  const itemStepWidth = (el) => {
    const w  = el.getBoundingClientRect().width;
    const mr = parseFloat(getComputedStyle(el).marginRight) || 0;
    if (mr > 0) return w + mr;
    if (flexGap > 0) return w + flexGap;
    return w + gapFallback;
  };

  const sumTrackWidth = () => {
    let s = 0;
    for (const el of track.children) s += itemStepWidth(el);
    return s;
  };

  const ensureBuffer = () => {
    const need = container.offsetWidth * 2;
    let guard = 0;
    while (sumTrackWidth() < need && guard < 40) {
      originals.forEach(n => track.appendChild(n.cloneNode(true)));
      guard++;
    }
  };

  track.innerHTML = "";
  originals.forEach(n => track.appendChild(n.cloneNode(true)));
  ensureBuffer();

  let pos = direction === "right" ? -itemStepWidth(track.firstElementChild) : 0;
  let speed = baseSpeed;
  let raf;

  const stepLeft = () => {
    pos -= speed;
    while (track.firstElementChild && -pos >= itemStepWidth(track.firstElementChild)) {
      const w = itemStepWidth(track.firstElementChild);
      track.appendChild(track.firstElementChild);
      pos += w;
    }
  };

  const stepRight = () => {
    pos += speed;
    while (pos > 0) {
      const last = track.lastElementChild;
      if (!last) break;
      const wBefore = itemStepWidth(last);
      track.insertBefore(last, track.firstElementChild);
      pos -= wBefore;
    }
  };

  const tick = () => {
    if (direction === "left") stepLeft(); else stepRight();
    track.style.transform = `translate3d(${pos}px,0,0)`;
    raf = requestAnimationFrame(tick);
  };

  const leftBtn  = container.querySelector(".carousel-arrow--left");
  const rightBtn = container.querySelector(".carousel-arrow--right");

  const startBoost = (dir) => { direction = dir; speed = baseSpeed * boostFactor; };
  const stopBoost  = () => { speed = baseSpeed; };

  const startEvts = ["pointerdown","mousedown","touchstart","keydown"];
  const stopEvts  = ["pointerup","mouseup","mouseleave","touchend","blur","keyup"];
  let lastDown = { left: 0, right: 0 };

  if (leftBtn) {
    startEvts.forEach(t => leftBtn.addEventListener(t, (ev) => {
      if (ev.type === "keydown" && !["Enter"," "].includes(ev.key)) return;
      startBoost("left");
      if (ev.type !== "keydown") lastDown.left = Date.now();
    }));
    stopEvts.forEach(t => leftBtn.addEventListener(t, stopBoost));
  }

  if (rightBtn) {
    startEvts.forEach(t => rightBtn.addEventListener(t, (ev) => {
      if (ev.type === "keydown" && !["Enter"," "].includes(ev.key)) return;
      startBoost("right");
      if (ev.type !== "keydown") lastDown.right = Date.now();
    }));
    stopEvts.forEach(t => rightBtn.addEventListener(t, stopBoost));
  }

  let boostTimeout;
  const turboMs = 3000, clickThreshold = 220;
  const boostFor = (ms, dir) => {
    direction = dir;
    speed = baseSpeed * boostFactor;
    clearTimeout(boostTimeout);
    boostTimeout = setTimeout(() => { speed = baseSpeed; }, ms);
  };
  if (leftBtn)  leftBtn.addEventListener("click",  () => { if (Date.now() - lastDown.left  < clickThreshold) boostFor(turboMs, "left"); });
  if (rightBtn) rightBtn.addEventListener("click", () => { if (Date.now() - lastDown.right < clickThreshold) boostFor(turboMs, "right"); });

  const rebuild = () => {
    cancelAnimationFrame(raf);
    ensureBuffer();
    tick();
  };

  let roTO;
  const ro = new ResizeObserver(() => { clearTimeout(roTO); roTO = setTimeout(rebuild, 80); });
  ro.observe(container);
  track.querySelectorAll("img").forEach(img => {
    if (!img.complete) img.addEventListener("load", rebuild, { once: true });
  });

  tick();
});

// columns with icon swiper
document.addEventListener("DOMContentLoaded", function () {
  let swiper = new Swiper(".columns-with-icon-swiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
      el: ".columns-with-icon-swiper-progressbar",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".columns-with-icon-swiper-arrows-next",
      prevEl: ".columns-with-icon-swiper-arrows-prev",
    },
    loop: false,
  });

  window.addEventListener("resize", function () {
    swiper.update();
    if (swiper.pagination && swiper.pagination.update) {
      swiper.pagination.update();
    }
  });
});
// swiper for testimonials
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".testimonials-swiper");
  if (!el) return;

  const slidesCount = el.querySelectorAll(".swiper-slide").length;
  const maxDesktop = 3;

  new Swiper(el, {
    loop: true,
    spaceBetween: 16,
    watchOverflow: true,
    centerInsufficientSlides: true,
    slidesPerGroup: 1,
    allowTouchMove: slidesCount > 1,
    autoplay: { 
        delay: 3000, 
        disableOnInteraction: false, 
        pauseOnMouseEnter: true 
    },
    navigation:
      slidesCount > 1
        ? {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        : {},
    observer: true,
    observeParents: true,
    resizeObserver: true,

    slidesPerView: 1,

    breakpoints: {
      768: {
        slidesPerView: Math.min(slidesCount, 2),
        spaceBetween: 20,
      },
      992: {
        slidesPerView: Math.min(slidesCount, 2),
      },
      1200: {
        slidesPerView: Math.min(slidesCount, maxDesktop),
      },
    },
  });
});
/*slider-cards*/
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 600;
    const swiperCards = new Swiper(".slider-cards-swiper", {
        slidesPerView: "auto",
        spaceBetween: 30,
        freeMode: true,
        loop: true,
        autoplay: isMobile ? false : {
            delay: 2000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".slider-cards-button-next",
            prevEl: ".slider-cards-button-prev",
        },
        pagination: false,
        on: {
            init: function () {
                updateProgressBar(this);
            },
            slideChange: function () {
                updateProgressBar(this);
            },
            resize: function () {
                updateProgressBar(this);
            },
        },
        breakpoints: {
            1400: {
                slidesPerView: "auto",
                spaceBetween: 26,
            },
            1200: {
                slidesPerView: "auto",
                spaceBetween: 26,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            600: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            0: {
                slidesPerView: 1,
                centeredSlides: false,
                loop: false,
            },
        },
    });

    function updateProgressBar(swiper) {
        if (swiper.params.slidesPerView !== 1) return;

        const totalSlides = swiper.slides.length;
        const activeIndex = swiper.activeIndex;
        const progress = ((activeIndex + 1) / totalSlides) * 100;

        const progressFill = document.querySelector(".progress-fill");
        if (progressFill) {
            progressFill.style.width = progress + "%";
        }
    }
});

/*upload file */
function applyCustomFileWrapper($) {
  $('input[type="file"]').each(function () {
    const $input = $(this);

    if ($input.parent().hasClass("file-pseudo-wrapper")) return;

    const $wrapper = $(
      '<label class="file-pseudo-wrapper" data-file-name=""></label>'
    );
    $input.wrap($wrapper);
    const $realWrapper = $input.parent();

    $input.on("change", function () {
      const fileName = this.files[0]
        ? this.files[0].name
        : "Upload your resume";
      $realWrapper.attr("data-file-name", fileName);
    });
  });
}

jQuery(document).ready(function ($) {
  applyCustomFileWrapper($);

  $(document).on("gform_post_render", function () {
    applyCustomFileWrapper($);
  });
});

// Auto-scroll to results section on pagination navigation
function scrollToResults() {
  if (window.location.pathname.includes("/page/")) {
    const anchor = document.getElementById("results-anchor");
    if (anchor) {
      setTimeout(
        () => anchor.scrollIntoView({ behavior: "smooth", block: "start" }),
        500
      );
    }
  }
}

document.addEventListener("DOMContentLoaded", scrollToResults);
document.addEventListener("click", function (e) {
  if (e.target.closest(".page-numbers")) {
    setTimeout(scrollToResults, 500);
  }
});

// Slider Columns Bracket Heading
document.addEventListener("DOMContentLoaded", function () {
  let swiper = null;
  const parent = document.querySelector(".columns-bracket-heading");
  if (!parent) return;

  const swiperContainer = parent.querySelector(".columns-row");
  const swiperSlides = parent.querySelectorAll(".columns-row-col");
  let swiperWrapper = null;

  function initSwiper() {
    if (window.innerWidth < 768) {
      if (!swiperWrapper) {
        swiperWrapper = document.createElement("div");
        swiperWrapper.className = "column-row-wrapper swiper-wrapper";
        swiperSlides.forEach((slide) => slide.classList.add("swiper-slide"));

        const columns = swiperContainer.querySelectorAll(".columns-row-col");
        columns.forEach((column) => {
          swiperWrapper.appendChild(column);
        });

        swiperContainer.appendChild(swiperWrapper);
        swiperContainer.classList.add("swiper");

        swiper = new Swiper(".columns-row.swiper", {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: ".slider-swiper-progressbar",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".slider-swiper-arrows-next",
            prevEl: ".slider-swiper-arrows-prev",
          },
          on: {
            init: function () {
              if (AOS) AOS.refresh();
            },
            slideChange: function () {
              if (AOS) AOS.refreshHard();
            },
          },
        });
      }
    } else {
      if (swiperWrapper) {
        swiperContainer.classList.remove("swiper");

        const columns = swiperWrapper.querySelectorAll(".columns-row-col");
        const buttons = swiperContainer.querySelectorAll(".custom-btn");

        swiperSlides.forEach((slide) => slide.classList.remove("swiper-slide"));

        columns.forEach((column) => {
          swiperContainer.appendChild(column);
        });

        buttons.forEach((button) => {
          if (!swiperContainer.contains(button)) {
            swiperContainer.appendChild(button);
          }
        });

        swiperWrapper.remove();
        swiperWrapper = null;

        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
        if (AOS) AOS.refresh();
      }
    }
  }

  initSwiper();

  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initSwiper, 250);
  });
});
